import React, { useState, useEffect } from "react";
import isLoggedIn from "../../../components/isLoggedIn";
import Heart from "../../icons/Heart";
import isProductInFav from "../utils/isProductInFav";
import HeartFilled from "../../icons/HeartFilled";
import addToFav from "../utils/addToFav";
import removeFromFav from "../utils/removeFromFav";

const Icon = (props) => {
  const [logged, setLogged] = useState(isLoggedIn());
  const [added, setAdded] = useState(false);

  useEffect(() => {
    checkIsAdded();
  }, [props.product]);

  const checkIsAdded = () => {
    isProductInFav(props.product).then((added) => {
      setAdded(added);
    });
  };

  const addFav = () => {
    if (!props.lock) {
      addToFav(props.product);
      setAdded(true);
    }
  };

  const removeFav = () => {
    if (!props.lock) {
      removeFromFav(props.product);
      setAdded(false);
    }
  };

  return (
    <div className={'heart'} onClick={added ? removeFav : addFav}>
      {added ? <HeartFilled /> : <Heart />}
    </div>
  );
};

export default Icon;
